import React from 'react';
import css from './index.css';
import face from "../../assets/img/face.png";
import linkden from "../../assets/icon/linkden.svg";
import github from "../../assets/icon/github.svg";
import tele from "../../assets/icon/tele.svg";
import mail from "../../assets/icon/mail.svg";
import {useTranslation} from 'react-i18next';

export default function Header() {

const {t,i18n}=useTranslation();

const changelanguage=(e)=>{
  localStorage.setItem('i18next-lang',e.target.value);
 i18n.changeLanguage(e.target.value)
}

  return (
    <header>
    <nav>
    <h1>Aziz Mobarak</h1>
    <div>
    <a href="../pdf/cv.pdf" download><button>Download</button></a>
    <select value={localStorage.getItem('i18next-lang') !== null ? localStorage.getItem('i18next-lang') : "en"} onChange={changelanguage}>
    <option value="en"> English </option>
    <option value="fr"> Francais </option>
    </select>
    </div>
    </nav>
    <div className="profile1">
    <div>
    <ul>
    <li><img src={linkden} width="20" /> : <a style={{ color:"white" }} href="https://www.linkedin.com/in/aziz-mobarak-652758160/">{t('linkden.label')}</a></li>
    <li><img src={github} width="20" /> : <a style={{ color:"white" }} href="https://github.com/azizmobarak">{t('github.label')}</a></li>
    </ul>
    </div>
    <img className="face" src={face}/>
    <div>
    <ul>
    <li><img src={tele} width="20" /> : +212 (0) 7 62 08 62 66</li>
    <li><img src={mail} width="20" /> : mobarakaziz9@gmail.com</li>
    </ul>
    </div>
    </div>

    {/* ------- Mobile View ------ */}
    <div className="profile2">
    <img className="face" src={face}/>
    <div>
    <ul>
    <li><img src={linkden} width="20" /> : <a style={{ color:"white" }} href="https://www.linkedin.com/in/aziz-mobarak-652758160/">{t('linkden.label')}</a></li>
    <li><img src={github} width="20" /> : <a style={{ color:"white" }} href="https://github.com/azizmobarak">{t('github.label')}</a></li>
    </ul>
    </div>
    <div>
    <ul>
    <li><img src={tele} width="20" /> : +212 (0) 7 62 08 62 66</li>
    <li><img src={mail} width="20" /> : mobarakaziz9@gmail.com</li>
    </ul>
    </div>
    </div>
    {/* ------- Mobile View  end ------ */}

    <h2>{t('developer.label')}</h2>
    </header>
  );
}
